__webpack_require__.p = "//static-asset-prod.nykaafashion.com/new-static-checkout/";